import DashliteCover from "../assets/images/project-covers/dashlite_cover.png";
import BookaiCover from "../assets/images/project-covers/Bookai_cover.png";
import HealthosCover from "../assets/images/project-covers/healthos_cover.png";
import VasperCover from "../assets/images/project-covers/vaspar.png";
import DonorPointCover from "../assets/images/project-covers/donorpoint_cover.png";
import FivelyCover from "../assets/images/project-covers/project_cover.png";

export const projectData = [
    {
        id: 1,
        theme: "pink",
        name: "Dashlite React",
        details: "Dashlite is a powerful admin template design primarily to sell as a template in Themeforest.",
        cover: DashliteCover,
        link: "https://themeforest.net/item/dashlite-react-admin-dashboard-template/34797909?gclid=Cj0KCQiA4aacBhCUARIsAI55maHWMBIO9zMVBT7ASlMeNPTWWTO2lun50hS4BxFeBtaHJGrsecgsyvsaAuAjEALw_wcB",
    },
    {
        id: 2,
        theme: "gray",
        name: "DonorPoint",
        details: "An AI powered platform connecting donors and beneficiaries",
        cover: DonorPointCover,
        link: "https://github.com/Ashraf-Raneem/Donation-share",
    },
    {
        id: 3,
        theme: "secondary",
        name: "Bookai",
        details: "It is an AI powered platform where user can search, read summazied abstract and leave a review",
        cover: BookaiCover,
        link: "https://github.com/Ashraf-Raneem/Bookai",
    },
    {
        id: 4,
        theme: "light",
        name: "HealthOs",
        details: "A native app, digitalizing the process of purchasing medicines for pharmacies in Bangladesh.",
        cover: HealthosCover,
        link: "https://play.google.com/store/apps/details?id=io.healthos.androidecom&utm_source=website&utm_campaign=start&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&pli=1",
    },
    {
        id: 5,
        theme: "red",
        name: "Fively App",
        details: "Fively is a react native ecommerce app, where users can browse and purchase.",
        cover: FivelyCover,
        link: "https://github.com/Ashraf-Raneem/fively-app",
    },
    {
        id: 6,
        theme: "white",
        name: "Vasper Clothing",
        details: "It is a simple personal project, featuring an ecommerce site",
        cover: VasperCover,
        link: "https://github.com/Ashraf-Raneem/Vasper-Clothing",
    },
];
